import { render, staticRenderFns } from "./DeleteSitetypeDialog.vue?vue&type=template&id=6df5a400&scoped=true"
import script from "./DeleteSitetypeDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSitetypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5a400",
  null
  
)

export default component.exports